export default __webpack_public_path__ + "static/media/home-banner.1aed73fc.jpg";